export default "__VITE_ASSET__BoO$Siw3__"